/* Mega-panel predictive search (desktop header).
   Self-contained on purpose: the theme bundle's initPredictiveSearch() no-ops
   because the old [data-predictive-results] container was removed from the
   header — this file owns the desktop dropdown instead. i18n is hardcoded
   English like rider-fit-verify (locale editor strips custom keys). */
(function () {
  "use strict";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* --- generic size recommendation (mirrors core/size-finder-core.js) --- */
  function parseSizeRows(text) {
    if (typeof text !== "string") return [];
    return text.replace(/\\n/g, "\n").split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean)
      .map(function (l) {
        var p = l.split("|");
        return { label: (p[0] || "").trim(), min: Number(p[1]), max: Number(p[2]) };
      })
      .filter(function (r) { return r.label && isFinite(r.min) && isFinite(r.max) && r.min <= r.max; })
      .sort(function (a, b) { return a.min - b.min; });
  }
  function recommendSize(value, rows) {
    var v = Number(value);
    if (!rows.length || !isFinite(v)) return null;
    for (var i = 0; i < rows.length; i++) if (v >= rows[i].min && v <= rows[i].max) return rows[i].label;
    if (v < rows[0].min) return rows[0].label;
    if (v > rows[rows.length - 1].max) return rows[rows.length - 1].label;
    var best = rows[0], bestDist = Infinity;
    rows.forEach(function (r) {
      var d = v < r.min ? r.min - v : v - r.max;
      if (d < bestDist) { bestDist = d; best = r; }
    });
    return best.label;
  }
  function loadPassSize(rows) {
    try {
      var p = JSON.parse(localStorage.getItem("ip_helm_pass"));
      if (!p || p.version !== 1 || !isFinite(Number(p.umfang_cm))) return null;
      return recommendSize(p.umfang_cm, rows);
    } catch (_) { return null; }
  }

  function init() {
    var root = document.querySelector("[data-predictive]");
    var panel = document.querySelector("[data-megasearch]");
    var cfgEl = document.querySelector("[data-megasearch-config]");
    if (!root || !panel || !cfgEl) return;
    var input = root.querySelector("input[type='search']");
    if (!input) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (_) { cfg = {}; }
    var searchUrl = cfg.searchUrl || "/search";
    var sizeRows = parseSizeRows(cfg.sizeRows || "");
    var money;
    try {
      money = new Intl.NumberFormat(cfg.locale || "en", { style: "currency", currency: cfg.currency || "EUR" });
    } catch (_) {
      money = { format: function (n) { return n.toFixed(2) + " " + (cfg.currency || "EUR"); } };
    }
    function fmt(v) {
      var n = Number(v);
      return isFinite(n) ? money.format(n) : esc(v);
    }

    var SIC = '<svg class="ms__sic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';

    function allUrl(q) { return searchUrl + "?q=" + encodeURIComponent(q) + "&type=product"; }

    /* typed part muted, completion bold (Amazon convention) */
    function highlight(text, q) {
      var t = String(text || ""), lq = q.toLowerCase();
      if (t.toLowerCase().indexOf(lq) === 0) {
        return '<span class="ms__match">' + esc(t.slice(0, q.length)) + "</span> <b>" + esc(t.slice(q.length).trim()) + "</b>";
      }
      return "<b>" + esc(t) + "</b>";
    }

    function productCard(p, mySize) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || "");
      if (img) img += (img.indexOf("?") >= 0 ? "&" : "?") + "width=360";
      var price = Number(p.price);
      var was = Number(p.compare_at_price_max || p.compare_at_price || 0);
      var onSale = isFinite(was) && was > price;
      var pct = onSale ? Math.round((1 - price / was) * 100) : 0;
      var isHelmet = /helmet/i.test(p.type || "");
      return (
        '<a class="ms__card" href="' + encodeURI(p.url) + '">' +
          '<span class="ms__cimg">' +
            (onSale && pct > 0 ? '<span class="ms__off">-' + pct + "%</span>" : "") +
            (img ? '<img src="' + esc(img) + '" alt="" decoding="async">' : "") +
          "</span>" +
          "<strong>" + esc(p.title) + "</strong>" +
          '<span class="ms__price' + (onSale ? " is-sale" : "") + '">' + fmt(p.price) +
            (onSale ? " <s>" + fmt(was) + "</s>" : "") + "</span>" +
          (isHelmet && mySize ? '<span class="ms__fit"><i>✓</i> Your size · ' + esc(mySize) + "</span>" : "") +
        "</a>"
      );
    }

    function render(data, q) {
      var r = (data.resources && data.resources.results) || {};
      var queries = (r.queries || []).slice(0, 4);
      var collections = (r.collections || []).slice(0, 4);
      var products = (r.products || []).slice(0, 6);
      var mySize = loadPassSize(sizeRows);

      /* collection matching the query verbatim → brand-style card */
      var brand = null;
      var lq = q.toLowerCase();
      collections = collections.filter(function (c) {
        if (!brand && String(c.title || "").toLowerCase() === lq) { brand = c; return false; }
        return true;
      });

      /* categories = distinct product types of the results */
      var types = [];
      products.forEach(function (p) {
        if (p.type && types.indexOf(p.type) < 0) types.push(p.type);
      });
      types = types.slice(0, 4);

      var rail = "";
      if (queries.length) {
        rail += '<div class="ms__lab">Suggestions</div>' + queries.map(function (s) {
          return '<a class="ms__q" href="' + allUrl(s.text) + '">' + SIC + "<span>" + highlight(s.text, q) + "</span></a>";
        }).join("");
      }
      if (types.length || collections.length) {
        rail += '<div class="ms__lab">Categories</div>' +
          types.map(function (t) {
            return '<a class="ms__c" href="' + allUrl(q) + "&filter.p.product_type=" + encodeURIComponent(t) + '">' + esc(t) + "</a>";
          }).join("") +
          collections.map(function (c) {
            return '<a class="ms__c" href="' + encodeURI(c.url) + '">' + esc(c.title) + "</a>";
          }).join("");
      }
      if (brand) {
        rail += '<a class="ms__brand" href="' + encodeURI(brand.url) + '">' +
          "<span><strong>" + esc(brand.title) + "</strong><small>Official brand page</small></span>" +
          '<span class="ms__brand-ar">→</span></a>';
      }

      var main;
      if (products.length) {
        main =
          '<div class="ms__mh"><h4>Products</h4><a class="ms__all" href="' + allUrl(q) + '">View all →</a></div>' +
          '<div class="ms__cards">' + products.map(function (p) { return productCard(p, mySize); }).join("") + "</div>" +
          (mySize ? '<div class="ms__strip"><i>✓</i> <span><b>Rider-ID active:</b> sizes are matched against your Helm-Pass.</span></div>' : "");
      } else {
        main = '<div class="ms__empty">No results for &ldquo;' + esc(q) + '&rdquo;<small>Check the spelling or try a brand, model or part name.</small></div>';
      }

      panel.innerHTML =
        '<div class="ms__rail">' + (rail || '<div class="ms__lab">Search</div>') + "</div>" +
        '<div class="ms__main">' + main + "</div>";
      panel.hidden = false;
    }

    var timer = null, seq = 0;
    function run(q) {
      clearTimeout(timer);
      if (q.length < 2) { panel.hidden = true; return; }
      timer = setTimeout(function () {
        var mine = ++seq;
        var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
          "&resources[type]=product,collection,query&resources[limit]=8&resources[options][unavailable_products]=last";
        fetch(url, { headers: { Accept: "application/json" } })
          .then(function (res) { return res.json(); })
          .then(function (data) { if (mine === seq) render(data, q); })
          .catch(function () { if (mine === seq) panel.hidden = true; });
      }, 250);
    }

    input.addEventListener("input", function (e) { run(e.target.value.trim()); });
    input.addEventListener("focus", function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) panel.hidden = false;
    });
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target) && !panel.contains(e.target)) panel.hidden = true;
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") panel.hidden = true;
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
